// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"zi","centerLink":"Ai","productSection":"Bi","item":"Ci","ctaButton":"Di"};